// frontend/src/pages/club/ClubTickets/ClubTickets.jsx
import TicketsView from '../../../components/tickets/TicketsView';

export default function ClubTickets() {
  return <TicketsView />;
}